import { Record } from "immutable";

const defaults = {
    __data: [],
    __default_date_range: undefined,
    __default_open: false,
    __key: undefined,
    __max_key: undefined,
    __min_date: undefined,
    __min_key: undefined,
    __name: undefined,
    __type: undefined,
    __uri: undefined,
    __uri_key: undefined,
    __extract_id_for_query: undefined,
    _id: undefined,
};

export class FilterRecord extends Record(defaults) {
    declare _id: string;
    declare __default_open: boolean;
    declare __key: string;
    declare __name: string;
    declare __type: string;
    declare __uri: string;
    declare __uri_key: boolean;
    declare __min_key: string;
    declare __max_key: string;
    declare __data: object;
    declare __min_date: number;
    declare __default_date_range: number;
    declare __convert_to_id: boolean;
    declare __extract_id_for_query: boolean;

    constructor(args: any = {}) {
        super({
            ...args,
        });
    }

    toDataTest(attr) {
        return this.get(attr).replace(/__/g, "").replace(".", "-").replace("_", "-").replace(/\s+/g, "-").toLowerCase();
    }
}

export default FilterRecord;
